module.exports = __webpack_public_path__ + "static/media/img-01.96cf932f.jpg";